var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { getSprinklerSampling } from '../services/SprinklerSamplingService';
import { sprinklerSamplingKeys } from './queryKeys';
export function useSprinklerSamplingQuery(params) {
    return useQuery({
        queryKey: sprinklerSamplingKeys.table(params),
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            const response = yield getSprinklerSampling(params);
            if (response.error) {
                throw new Error(response.error.message);
            }
            return response.data;
        }),
        staleTime: 2 * 60 * 1000, // 2 minutes
        cacheTime: 5 * 60 * 1000 // 5 minutes
    });
}
